import { DASHBOARDS } from '../enum/dashboards';
import { USER_ROLE } from '../enum/user-roles';

export class CompanyAccount {
    constructor(data?: Partial<CompanyAccount>) {
        Object.assign(this, data);
    }

    dashboards: string[];
    role: string;
    type: string;
    name: string;
    id: number;
    rawValue: string;
    domain: string;

    isAdmin = (): boolean => this.role === USER_ROLE.ADMIN;
    hasDashboard = (dashboard: string): boolean => this.dashboards.indexOf(dashboard) >= 0;
    isManagementAccount = (): boolean => this.hasDashboard(DASHBOARDS.MANAGEMENT);

    equal = (account: CompanyAccount): boolean => {
        try {
            return (
                this.id === account.id &&
                this.name === account.name &&
                this.role === account.role &&
                this.type === account.type &&
                this.domain === account.domain &&
                this.dashboards.length === account.dashboards.length &&
                this.dashboards.every((dashboard) => account.dashboards.includes(dashboard)) &&
                account.dashboards.every((dashboard) => this.dashboards.includes(dashboard))
            );
        } catch {
            return false;
        }
    };
}
